import moment from 'moment'

const setWithExpiry = (key, value, days) => {
  const expiryDay = moment().add(days, 'days').format('DD.MM.YYYYTHH:mm:ss')
  const item = {
    value: value,
    expiry: expiryDay
  }
  localStorage.setItem(key, JSON.stringify(item))
}
const get = (key) => {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  if (moment().isSameOrAfter(moment(item.expiry, 'DD.MM.YYYYTHH:mm:ss'))) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}
const remove = (key) => {
  localStorage.removeItem(key)
}

export default { setWithExpiry, get, remove }
